<template>
  <div class="px-8">
    <div style="height: 105px;" class="d-flex align-center">
        <div
            @click="$router.push({ name: routeNames.MY_ACCOUNT })"
            class="circle d-flex justify-center align-center"
        >
            <v-icon
                size="30"
                color="#000230"
            >
                {{ "arrow_back" }}
            </v-icon>
        </div>
    </div>
    <div class="d-flex justify-center align-center">
        <v-icon
            size="24"
            color="#000230"
        >
            {{ "sync" }}
        </v-icon>
        <p class="mt-4 ml-2" style="font-size: 25px; font-weight: 700; color: var(--primary-color-blue);">{{ $t("my_account.change_password") }}</p>
    </div>
    <div v-if="!passwordChanged">
        <div>
            <v-col style="color: var(--primary-color-blue);" class="py-5" v-for="(field, i) in passwordFields" :key="i" :class="field.model === 'changePassword.currentPassword' ? 'mb-12' : ''">
                <v-row style="font-size: 14px;">
                  {{ field.text }}*
                </v-row>
                <v-row align="center" justify="space-around">
                  <v-text-field
                    flat
                    solo
                    hide-details
                    single-line
                    :append-icon="
                        showPassword
                          ? 'visibility_off'
                          : 'visibility'
                    "
                    @click:append="showPassword = !showPassword"
                    :v-model="field.model"
                    :type="
                      showPassword ? 'text' : 'password'
                    "
                    class="input-custom w-100"
                  >
                  </v-text-field>
                  <span v-if="formErrors" class="red--text w-100">{{
                    formErrors['field.model']
                  }}</span>
                </v-row>
            </v-col>
    
        </div>
        <div
            @click="passwordChanged = !passwordChanged"
            class="mt-16 mb-3 px-5" 
            style="background: var(--primary-color-blue); border-radius: 16px; height: 65px;">
            <p style="color: white; font-size: 16px; font-weight: 500; height: 65px; line-height: 65px; text-align: center;">
                {{ $t("my_account.change_password") }}
            </p>
        </div>
        <p style="font-size: 16px; font-weight: 500; text-decoration: underline;" @click="$router.push({ name: routeNames.MY_ACCOUNT })" class="text-center">{{ $t('recover.go_back') }}</p>
    </div>

    <v-slide-x-transition hide-on-leave>
        <div
            v-if="passwordChanged"
            class="d-flex flex-column align-center justify-center vertical-semi-centered"
        >
            <v-row
                class="section-title font-weight-bold d-flex align-center justify-center"
                >
                <v-icon style="font-size: 62px !important;" color="#34A853" class="big-icon my-6">
                    {{ 'check_circle' }}
                </v-icon>
                <span
                    style="font-size: 25px; font-weight: 700; line-height: 100%;"
                    class="display"
                    >{{ $t('my_account.password_changed') }}</span
                >
            </v-row>
            <v-row class="pt-10 w-100">
                <v-btn
                    style="background: var(--primary-color-blue);"
                    class="textOverSecondary--text semi-rounded my-8 mx-auto px-10 py-8 w-100"
                    @click="$router.push({ name: routeNames.MY_ACCOUNT })"
                >
                    {{ $t("actions.ok") }}
                </v-btn>
            </v-row>
        </div>
    </v-slide-x-transition>

  </div>
</template>
<script>
import routeNames from "@/router/route-names";

export default {
  props: ["auth"],
  data() {
    return {
        showPassword: false,
        formErrors: null,
        changePassword: {
            currentPassword: null,
            newPassword: null,
            repeatNewPassword: null,
        },
        passwordFields: [
            {
                model: "changePassword.currentPassword",
                text: "Contraseña actual"
            },
            {
                model: "changePassword.newPassword",
                text: "Nueva contraseña"
            },
            {
                model: "changePassword.repeatNewPassword",
                text: "Repetir nueva contraseña"
            }
        ],
        routeNames: routeNames,
        passwordChanged: false
    };
  },
};
</script>

<style scoped>
.circle {
  width: 52px !important;
  height: 52px !important;
  background-color: #0002300D !important;
  border-radius: 50% !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
</style>
